var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507.9 659.5",
    style: {
      enableBackground: "new 0 0 507.9 659.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.2,0c-0.2,0-0.5,0-0.7,0c-0.4,0-0.8,0-1.2,0c-0.2,0-0.5,0-0.8,0c-50.7,0.1-92.8,16-126.1,47.4 C95,79.1,77.6,120.9,76.2,172.9l-1.1,76.6c-20.7,0.1-38.4,7.4-53.1,22.1C7.4,286.4,0,304.2,0,325v259c0,20.8,7.4,38.6,22.1,53.3 c14.8,14.8,32.6,22.2,53.4,22.2h356.9c20.8,0,38.6-7.4,53.4-22.2c14.8-14.7,22.2-32.5,22.1-53.3V325c0-20.8-7.4-38.6-22.1-53.4 c-7.4-7.4-15.5-12.9-24.5-16.6c-4.4-1.8-9.1-3.2-13.9-4.1c-3.5-0.6-7.1-1.1-10.8-1.2l-1-76.8c-1.3-52-18.7-93.8-52.2-125.4 C350.1,16,308,0.2,257.2,0 M51,325c0-6.8,2.4-12.5,7.2-17.4c4.8-4.8,10.6-7.1,17.3-7.1h356.9c6.8,0,12.5,2.4,17.3,7.1 c4.8,4.8,7.2,10.6,7.2,17.4v259c0,6.8-2.4,12.5-7.2,17.3c-4.8,4.8-10.5,7.2-17.3,7.2H75.5c-6.8,0-12.5-2.4-17.3-7.2 c-4.8-4.8-7.1-10.5-7.2-17.3V325 M253,39.9c1.1,0,2.2-0.1,3.3-0.1c0.9,0,1.7,0.1,2.5,0.1c42.3,1.6,73.6,12.2,94.1,31.8 c20.5,19.6,33.3,35.8,38.5,48.5c2.2,5.3,4.3,11.6,6.3,19c1,3.6,1.7,6.7,2.3,9.3c2.9,38.3,3.1,72,0.4,101h-289 c-2.6-29-2.4-62.7,0.5-101c0.6-2.6,1.3-5.7,2.3-9.3c2-7.3,4.1-13.6,6.2-18.9c5.2-12.8,18.1-29,38.5-48.6 C179.4,52.1,210.8,41.5,253,39.9 M213.2,354.7c-11.1,11.2-16.7,24.6-16.7,40.3c0,15.7,5.5,29.2,16.7,40.2 c6.6,6.6,14.1,11.3,22.3,14V543c0,5.2,1.9,9.7,5.6,13.5c3.7,3.7,8.2,5.5,13.4,5.5s9.7-1.9,13.5-5.5c3.7-3.7,5.5-8.2,5.5-13.5 v-94.4c7.4-2.8,14.2-7.2,20.2-13.3c11.2-11.1,16.8-24.5,16.8-40.2c0-15.7-5.6-29.2-16.8-40.3c-11.1-11.1-24.5-16.7-40.2-16.7 S224.3,343.6,213.2,354.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock_icon.c007fbec.svg";
export { ForwardRef as ReactComponent };